import { IGetAllAddressesParams } from "./interfaces/IAddress";
import { apiConfig } from "../../config";
import ApiAddress from "./api-address";
import { Keys } from "../../common-interfaces/quiries-keys/keysValues";
import { getKey } from "../../common-interfaces/quiries-keys/queries-keys";
import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import { getAccessToken } from "@/utils/functions/cookieOperations";

export const AddressesPerPage = 2;
export const useAddress = () => new ApiAddress(apiConfig());
export const useGetAllAddressesQuery = (params: IGetAllAddressesParams) => {
  const addresses = useAddress();
  return useInfiniteQuery(
    [...getKey(Keys.get_all_addresses), getAccessToken()],
    ({ pageParam = { ...params } }) =>
      addresses.getAllAddressess(pageParam.page, pageParam.limit ?? 6),
    {
      getNextPageParam: (lastPage) => {
        const meta = lastPage.result.meta;
        const nextpage =
          meta.to < meta.total ? meta.current_page + 1 : undefined;
        return nextpage;
      },
      refetchOnWindowFocus: false,
    },
  );
};
// export const useGetAllAddressesPaginatedQuery = (params: IGetAllAddressesParams) => {
//   const addresses = useAddress();
//   return useQuery(
//     [Keys.get_all_addresses, Object.values(params), useLanguage()],
//     () => addresses.getAllAddressess(params.page, params.limit),
//     {
//       refetchOnWindowFocus: false,
//     },
//   );
// };
//create or edit address
export const useManageAddress = ({
  onSuccess,
  onError,
}: {
  onSuccess: (res: any) => void;
  onError: (err: any) => void;
}) => {
  const address = useAddress();
  const getAllAddressess = useGetAllAddressesQuery({ page: 1 });
  return useMutation(address.manageAddress, {
    onSuccess: (res: any) => {
      onSuccess(res);
      getAllAddressess.refetch();
    },
    onError: onError,
  });
};
export const useDeleteAddress = ({
  onSuccess,
  onError,
}: {
  onSuccess: (res: any) => void;
  onError: (err: any) => void;
}) => {
  const address = useAddress();
  const getAllAddressess = useGetAllAddressesQuery({ page: 1 });
  return useMutation(address.deleteAddress, {
    onSuccess: (res: any) => {
      onSuccess(res);
      getAllAddressess.refetch();
    },
    onError: onError,
  });
};
// export const getAllAddressesSSR = async (
//   queryClient: QueryClient,
//   locale: string,
//   host: string
// ) => {
//   const ssrAddress = new ApiAddress(apiConfig(locale, host));
//   await queryClient.prefetchQuery([Keys.get_all_addresses, locale], () =>
//     ssrAddress.getAllAddressess(1, 3)
//   );
// };
